import React from 'react';

const NoOptionsMessage = () => <span />;

export default NoOptionsMessage;
